/**
 * Core imports
 */
import Vue from 'vue';
import App from './App.vue';
import packageJson from '../package.json'

/**
 * Plugin imports
 */
import router from './router.js';
import BootstrapVue from "bootstrap-vue";
import VueLoadingOverlay from 'vue-loading-overlay';
import BackendService from "./core/backend/backend.service";
import store from './store';
import {i18n} from "./core/lang/i18n";
import {formatDate, formatPrice, nl2br} from "./helpers";
import Swal from 'sweetalert2'
import EventBus from './core/event';
import {empty} from "./helpers";

/**
 * Stylesheet imports
 */
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.min.css';

/**
 * Configurations
 */
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueLoadingOverlay, {
    color: "#b89453",
    zIndex: 99999999,
});

/**
 * Prototypes and bootstrapping
 */
Vue.prototype.$releaseText = 'BETA';

Vue.prototype.$eventBus = EventBus
Vue.prototype.$app = {
    version: packageJson.appVersion
};
Vue.prototype.$scrollTop = function () {
    let element = document.getElementsByName('body');
    let top = element.offsetTop;
    window.scrollTo(0, top);
};
Vue.prototype.$swal = Swal.mixin({
    confirmButtonColor: '#b89453',
    customClass: {
        icon: 'icon-wellis-gold'
    }
});

Vue.prototype.$helpers = {
    empty
};

Vue.filter('capitalize', function (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('toPrice', function (value, currency, vat) {
    return formatPrice(value, currency, vat);
});

Vue.filter('nl2br', function (value) {
    return nl2br(value);
});

Vue.filter('toUpper', function (value) {
    return value.toString().toUpperCase();
});

Vue.filter('toLower', function (value) {
    return value.toString().toLowerCase();
});

Vue.filter('formatDate', function (value, time = false, utc = false) {
    return formatDate(value, time, utc);
});

Vue.filter('cut', function (value, maxChar = 20) {
    if (value.length > maxChar) {
        return `${value.substr(0, maxChar).toString()}...`;
    }
    return value;
});

Vue.filter('niceBytesSize', function (bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
});

// Initializing backend api service.
BackendService.bootstrap();
Vue.prototype.$backend = BackendService;


/**
 * Creating a new Vue instance.
 */
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
